module.exports = __webpack_public_path__ + "img/56.66861550.png";